import {Fragment} from "preact";
import ChatRestrictionSettings from "../ChatRestrictionSettings/ChatRestrictionSettings";
import ChatMessageDisplaySettings from "../ChatMessageDisplaySettings/ChatMessageDisplaySettings";

const ChatSettings = ({ loading = false, restrictedUntil = '', onRestrict, onChangeMessageDisplayPeriodDays, messageDisplayPeriodDays = 0 }) => {
  return <Fragment>
    <ChatRestrictionSettings loading={loading} restrictedUntil={restrictedUntil} onRestrict={onRestrict} />
    <ChatMessageDisplaySettings loading={loading} messageDisplayPeriodDays={messageDisplayPeriodDays} onSetMessageDisplayPeriod={onChangeMessageDisplayPeriodDays} />
  </Fragment>;
};

export default ChatSettings;



// WEBPACK FOOTER //
// ./components/ChatSettings/ChatSettings.js